<template>
    <footer class="footer">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-md-12 text-center">
                    <a href="https://aospine.aofoundation.org/" target="_blank" class="text-muted">
                        <img src="./../assets/img/ao_spine_white_rgb.png">
                    </a>
                </div>
            </div>
        </div>
        <cookie-law v-on:accept="cookieThankYouMethod()" v-if="mycookies" theme="dark-lime" buttonText="Confirm">
            <div slot="message">
                Cookies help us improve your website experience.<br/>
                By using our website, you agree to our use of cookies.
            </div>
        </cookie-law>
    </footer>
</template>
<script>
import CookieLaw from 'vue-cookie-law'
export default {
    components: {
        CookieLaw
    },
    methods: {
        cookieThankYouMethod: function(format) {
           this.mycookies = false
        },
    },
    data() {
        return {
            mycookies: true
        }
    },
};
</script>
<style>
footer.footer {
    background-color: #001B62!important;
    min-height: 200px;
}
.Cookie--dark-lime {
    color: #fff !important;
    padding: 1em !important;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=95)";
    filter: alpha(opacity=95);
    -moz-opacity: 0.5;
    -khtml-opacity: 0.95;
    opacity: 0.95;
    text-align: center;
}
.Cookie__content {
    width: 100%;
}
.Cookie--dark-lime .Cookie__button {
    background: #3B7FF6!important;
    color: #ffffff!important;
}
footer img {
    height: 60px!important;
}
</style>



// WEBPACK FOOTER //
// src/layout/AppFooter.vue